import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { connectionString } from './connectionString.js';

export const reactPlugin = new ReactPlugin();

let appInsights = null;

export function initAppInsights({ history } = {}) {
  if (appInsights) return appInsights;

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      enableUnhandledPromiseRejectionTracking: true,
      autoTrackPageVisitTime: true,
      enableAjaxErrorStatusText: true,
      // Don't inject `Request-Id` / `traceparent` headers into cross-origin
      // requests — third-party APIs (Giphy, Unsplash, etc.) don't whitelist
      // them in CORS, so the browser blocks the preflight.
      enableCorsCorrelation: false,
      disableCorrelationHeaders: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history },
      },
    },
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();

  if (typeof window !== 'undefined') {
    window.addEventListener('error', (event) => {
      appInsights.trackException({
        exception: event.error || new Error(event.message),
        properties: { source: 'window.onerror', filename: event.filename, lineno: event.lineno, colno: event.colno },
      });
    });
  }

  return appInsights;
}

export const getAppInsights = () => appInsights;
export { withAITracking };
